/* ── Country Selector Web Component ── */
(function () {
  'use strict';

  /* ── Cookie helpers ── */
  function setCookie(name, value, minutes) {
    const maxAge = minutes * 60;
    document.cookie = `${name}=${encodeURIComponent(value)};max-age=${maxAge};path=/;SameSite=Lax;Secure`;
  }

  function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [key, val] = cookie.trim().split('=');
      if (key === name) return decodeURIComponent(val);
    }
    return undefined;
  }

  function deleteCookie(name) {
    document.cookie = `${name}=;max-age=0;path=/;SameSite=Lax;Secure`;
  }

  class CountrySelectorComponent extends HTMLElement {
    async connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.closeBtn = this.querySelector('.country-selector-close');
      this.overlay = this.querySelector('.country-selector-overlay');
      this.cookieDuration = parseInt(this.dataset.cookieDuration || '10080', 10);

      this.bindEvents();

      const autoDetect = this.dataset.autoDetect !== 'false';
      const hasChosen = getCookie('country-selector-chosen');
      if (autoDetect && !hasChosen && !getCookie('country-selector-dismissed') && !this.isThemeEditor()) {
        await this.autoShow();
      }
    }

    isThemeEditor() {
      return window.Shopify?.designMode === true;
    }

    bindEvents() {
      this.closeBtn?.addEventListener('click', () => this.dismiss());

      this.overlay?.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.dismiss();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-visible')) {
          this.dismiss();
        }
      });

      /* Set cookie when user explicitly chooses a market, then navigate */
      this.querySelectorAll('.country-selector-item').forEach((item) => {
        item.addEventListener('click', (e) => {
          const href = item.getAttribute('href');
          if (href) {
            e.preventDefault();
            const code = item.dataset.countryCode || 'chosen';
            deleteCookie('country-selector-chosen');
            deleteCookie('country-selector-dismissed');
            setCookie('country-selector-chosen', code, 10080); /* 7 days */
            window.location.href = href;
          }
        });
      });
    }

    async autoShow() {
      try {
        const response = await fetch('/browsing_context_suggestions.json');
        const data = await response.json();
        const detectedCountry = data.detected_values.country.handle;
        const currentCountry = window.Shopify?.country || '';

        if (detectedCountry && currentCountry &&
            detectedCountry.toUpperCase() !== currentCountry.toUpperCase()) {
          this.highlightSuggested(detectedCountry);
          this.show();
        }
      } catch (e) {
        /* Silently fail — don't show modal if detection fails */
      }
    }

    highlightSuggested(countryCode) {
      const items = this.querySelectorAll('.country-selector-item[data-country-code]');
      let matched = false;
      let fallback = null;

      items.forEach((item) => {
        if (item.dataset.countryCode.toUpperCase() === 'EU') {
          fallback = item;
        } else if (item.dataset.countryCode.toUpperCase() === countryCode.toUpperCase()) {
          item.classList.add('is-suggested');
          matched = true;
        }
      });

      if (!matched && fallback) {
        fallback.classList.add('is-suggested');
      }
    }

    show() {
      this.classList.add('is-ready');
      void this.offsetWidth;
      requestAnimationFrame(() => {
        this.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      });
    }

    dismiss() {
      this.classList.remove('is-visible');
      document.body.style.overflow = '';
      setCookie('country-selector-dismissed', 'true', this.cookieDuration);
      setTimeout(() => {
        this.classList.remove('is-ready');
      }, 350);
    }

    open() {
      this.show();
    }
  }

  if (!customElements.get('country-selector-component')) {
    customElements.define('country-selector-component', CountrySelectorComponent);
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-country-selector-trigger]');
    if (!trigger) return;
    e.preventDefault();
    const selector = document.querySelector('country-selector-component');
    if (selector) selector.open();
  });
})();
